import { makeAutoObservable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'
import { MicrosoftAttachment } from '@libs/azure-graph'
import EmailModel from './Email'

class EmailAttachmentModel {
  public readonly rawObject: MicrosoftAttachment

  /** The id of the attachment **/
  public readonly id: string = uuidv4()

  public readonly isInline: boolean = true

  public readonly mailboxEmailAddress: string = ''
  public readonly emailId: string = ''
  public readonly contentId: string = ''
  public readonly contentType: string = ''
  public readonly name: string = ''
  public readonly size: string = ''

  public binaryContent?: ArrayBuffer

  public parent?: EmailModel

  constructor(mailboxEmailAddress: string, data: MicrosoftAttachment) {
    this.rawObject = data
    Object.assign(this, { mailboxEmailAddress, ...data })

    makeAutoObservable(this)
  }
}

export default EmailAttachmentModel
